export default function GlobeArt({
  className = "",
  stroke = "#0755C9",
  stroke2 = "#8FA3BC",
  animated = true,
}) {
  return (
    <svg
      viewBox="0 0 1440 560"
      fill="none"
      className={className}
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <g opacity="0.55">
        <circle cx="720" cy="1000" r="640" stroke={stroke2} strokeWidth="1.5" />
        <ellipse cx="720" cy="1000" rx="640" ry="250" stroke={stroke2} strokeWidth="1" />
        <ellipse cx="720" cy="1000" rx="530" ry="205" stroke={stroke2} strokeWidth="1" />
        <ellipse cx="720" cy="1000" rx="410" ry="155" stroke={stroke2} strokeWidth="1" />
        <line x1="80" y1="1000" x2="1360" y2="1000" stroke={stroke2} strokeWidth="1" />
        <line x1="240" y1="820" x2="1200" y2="820" stroke={stroke2} strokeWidth="1" opacity="0.7" />
      </g>
      <path
        d="M-120 430 C 320 170, 1120 170, 1560 430"
        stroke={stroke}
        strokeWidth="2"
        opacity="0.65"
      />
      <path
        d="M-120 480 C 320 225, 1120 225, 1560 480"
        stroke={stroke2}
        strokeWidth="1.2"
        opacity="0.5"
      />
      <g className={animated ? "orbit-slow" : ""}>
        <ellipse
          cx="720"
          cy="290"
          rx="660"
          ry="170"
          stroke={stroke}
          strokeWidth="1.2"
          strokeDasharray="3 12"
          opacity="0.55"
        />
      </g>
      <g className={animated ? "orbit-slower" : ""}>
        <ellipse
          cx="720"
          cy="300"
          rx="560"
          ry="130"
          stroke={stroke2}
          strokeWidth="1"
          strokeDasharray="2 9"
          opacity="0.45"
        />
      </g>
      <circle cx="190" cy="330" r="5" fill={stroke} opacity="0.8" />
      <circle cx="1245" cy="235" r="4" fill={stroke2} opacity="0.9" />
      <circle cx="1030" cy="168" r="3.5" fill={stroke} opacity="0.7" />
    </svg>
  );
}

export function OrbitMark({ className = "" }) {
  return (
    <svg viewBox="0 0 28 28" fill="none" className={className} aria-hidden="true">
      <circle cx="14" cy="14" r="6" stroke="currentColor" strokeWidth="1.6" />
      <ellipse
        cx="14"
        cy="14"
        rx="12"
        ry="4.5"
        stroke="currentColor"
        strokeWidth="1.2"
        transform="rotate(-24 14 14)"
      />
      <circle cx="25" cy="8" r="1.8" fill="currentColor" />
    </svg>
  );
}
